import React from "react";

const ApplyPenaltyIcon = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            fill={fill}
            d="M25.473 15.682a7.389 7.389 0 0 1 4.628-2.573 5.597 5.597 0 0 0 2.574-1.738 5.742 5.742 0 0 0-.694-8.04 5.678 5.678 0 0 0-9.304 3.822 7.32 7.32 0 0 1-4.864 6.934l6.06 5.094c.205-1.29.758-2.5 1.6-3.499ZM2 31.334h24.753V34H2v-2.667Zm22.664-2.574L8.082 14.83l2.752-3.076 16.582 13.935-2.752 3.071Z"
        />
        <path fill={fill} d="M6 32a4 4 0 0 1 4-4h9a4 4 0 0 1 4 4H6Z" className="u_fill"/>
    </svg>
);

export default ApplyPenaltyIcon;